import Blockly from 'blockly/browser'
import Util, { defineBlock, getOptionsCode, isValidIdentifier } from '../Util'
import Mutators from '../Mutators'

defineBlock(
  'javascript_property_set',
  {
    message0: 'set %2 on %1 to be %3',
    args0: [
      {
        type: 'input_value',
        name: 'OBJECT',
        text: 'object'
      },
      {
        type: 'field_input',
        name: 'PROPERTY',
        text: ''
      },
      {
        type: 'input_value',
        name: 'VALUE',
        align: 'RIGHT'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Set object property value',
    colour: Util.colors.objects,
    inputsInline: true
  },
  function(block) {
    var object =
      Blockly.JavaScript.valueToCode(block, 'OBJECT', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var propertyName = block.getFieldValue('PROPERTY') || ''
    var propertyValue =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    const lhs = isValidIdentifier(propertyName)
      ? `${object}.${propertyName}`
      : `${object}['${propertyName}']`
    return `${lhs} = ${propertyValue};\n`
  }
)

defineBlock(
  'javascript_property_get',
  {
    message0: '%2 on %1',
    args0: [
      {
        type: 'input_value',
        name: 'OBJECT'
      },
      {
        type: 'field_input',
        name: 'PROPERTY',
        text: ''
      }
    ],
    output: null,
    tooltip: 'get object property value',
    colour: Util.colors.objects
  },
  function(block) {
    var object =
      Blockly.JavaScript.valueToCode(block, 'OBJECT', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var propertyName = block.getFieldValue('PROPERTY') || ''
    var code = isValidIdentifier(propertyName)
      ? `${object}.${propertyName}`
      : `${object}['${propertyName}']`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_computed_property_set',
  {
    message0: 'set %2 on %1 to be %3',
    args0: [
      {
        type: 'input_value',
        name: 'OBJECT',
        text: 'object'
      },
      {
        type: 'input_value',
        name: 'PROPERTY',
        text: ''
      },
      {
        type: 'input_value',
        name: 'VALUE',
        align: 'RIGHT'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Set object property value (computed property)',
    colour: Util.colors.objects,
    inputsInline: true
  },
  function(block) {
    var object =
      Blockly.JavaScript.valueToCode(block, 'OBJECT', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var propertyName =
      Blockly.JavaScript.valueToCode(block, 'PROPERTY', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var propertyValue =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    const lhs = `${object}[${propertyName}]`
    return `${lhs} = ${propertyValue};\n`
  }
)

defineBlock(
  'javascript_computed_property_get',
  {
    message0: '%2 on %1',
    args0: [
      {
        type: 'input_value',
        name: 'OBJECT'
      },
      {
        type: 'input_value',
        name: 'PROPERTY'
      }
    ],
    output: null,
    tooltip: 'get object property value (computed property)',
    colour: Util.colors.objects,
    inputsInline: true
  },
  function(block) {
    var object =
      Blockly.JavaScript.valueToCode(block, 'OBJECT', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var propertyName =
      Blockly.JavaScript.valueToCode(block, 'PROPERTY', Blockly.JavaScript.ORDER_ATOMIC) || 'null'
    var code = `${object}[${propertyName}]`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

// Set up a mutator for the object literal block to make its property set mutable
Mutators.registerNamedThingsMutator(
  'javascript_object_literal_mutator',
  'properties',
  'Which properties should be set'
)

defineBlock(
  'javascript_object_literal',
  {
    message0: 'object',
    output: null,
    tooltip: 'Creates a new object with properties',
    mutator: 'javascript_object_literal_mutator',
    colour: Util.colors.objects
  },
  function(block) {
    let optionsObject = getOptionsCode(this.chosenThings, block)
    let code = `${optionsObject}`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_json_parse',
  {
    message0: 'object from JSON %1',
    args0: [
      {
        type: 'input_value',
        name: 'JSON',
        check: 'String'
      }
    ],
    output: null,
    tooltip: 'Parses json string to object',
    colour: Util.colors.misc
  },
  function(block) {
    const json =
      Blockly.JavaScript.valueToCode(block, 'JSON', Blockly.JavaScript.ORDER_ATOMIC) || ''
    const code = `JSON.parse(${json})`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_json_stringify',
  {
    message0: 'JSON from object %1',
    args0: [
      {
        type: 'input_value',
        name: 'OBJECT'
      }
    ],
    output: null,
    tooltip: 'Serializes object to json',
    colour: Util.colors.misc
  },
  function(block) {
    const object =
      Blockly.JavaScript.valueToCode(block, 'OBJECT', Blockly.JavaScript.ORDER_ATOMIC) || null
    const code = `JSON.stringify(${object})`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)
